export default __webpack_public_path__ + "assets/poi.svg?cc3a66da6a9b3dbd699f7f23a453b0c8";